import MobileDetect from 'mobile-detect';
const mb = new MobileDetect(window.navigator.userAgent);
export function mobile() {
    return mb.mobile();
}